import React, { useCallback } from 'react';
import { Text, View, TouchableOpacity } from 'react-native';
import { useTranslation } from '@oolio-group/localization';
import {
  DocketDetailsProps,
  DocketDisplayViewAllCoursesItem,
} from '../../../common/types';
import DocketItemStyles from '../DocketItem.styles';
import { bulkSelectVar, selectedDocketVar } from '../../../state/apolloVars';
import Icon from '../../Icon/Icon';
import { useColors } from '../../../hooks/useColors';
import { useNotifierDisplayStyle } from '../../../hooks/useNotifierDisplayStyle';

export default function ViewAllCoursesLabel({
  docketItem,
  onToggleDocketDetails,
}: {
  docketItem: DocketDisplayViewAllCoursesItem;
  onToggleDocketDetails: (props: DocketDetailsProps) => void;
}) {
  const { translate } = useTranslation();
  const styles = DocketItemStyles();
  const isBulkMode = bulkSelectVar();
  const isSelected = Object.keys(selectedDocketVar())?.length > 0;
  const { colors } = useColors();
  const displayStyle = useNotifierDisplayStyle(docketItem.printerProfileId);

  const handlePress = useCallback(() => {
    onToggleDocketDetails({
      docketId: docketItem.docketId,
      items: docketItem.items,
      notifierItems: docketItem.notifierItems,
      orderNumber: docketItem.orderNumber || '',
      status: docketItem.status,
      orderTypeId: docketItem.orderTypeId,
      displayStyle,
    });
  }, [docketItem, onToggleDocketDetails, displayStyle]);

  if (!docketItem.removedCourses.length) {
    return null;
  }

  return (
    <TouchableOpacity onPress={handlePress} disabled={isBulkMode || isSelected}>
      <View style={styles.otherItemsContainer}>
        <View style={styles.viewAllCoursesTextContainer}>
          <Text style={styles.viewAllCoursesTitle}>
            {translate('kitchenDisplay.viewAllCourses')}
          </Text>
          <Text style={styles.viewAllCoursesSubtitle}>{docketItem.name}</Text>
        </View>
        <View style={styles.viewAllCoursesCountBadge}>
          <Text style={styles.viewAllCoursesCountLabel}>
            {docketItem.removedCourses.length}
          </Text>
        </View>
        <Icon color={colors.text} name={'angle-right'} />
      </View>
    </TouchableOpacity>
  );
}
